import { useNavigate } from "react-router-dom";
import { GoHistory } from "react-icons/go";
import { MdOutlineHome } from "react-icons/md";
import { BiUser } from "react-icons/bi";

export const Tabbar = ({menu}) => {
    const navigate = useNavigate();
    // メニュー選択
    const selectMenu = (menu) => {
        // console.log(page);
        navigate("/" + menu);
    };
    return (
        <div className="tabbar">
            <ul className="menu_list">
                <li className={menu === 'home' ? ("menu active  text-center") : ("menu text-center")} onClick={() => selectMenu('home')}>
                    <div className="h3 menu_icon">
                        <MdOutlineHome />
                    </div>
                    <div className="">
                        <small>ホーム</small>
                    </div>
                </li>
                <li className={menu === 'orders' ? ("menu active  text-center") : ("menu text-center")} onClick={() => selectMenu('orders')}>
                    <div className="h4 menu_icon2">
                        <GoHistory />
                    </div>
                    <div className="menu_orders">
                        <small>注文履歴</small>
                    </div>
                </li>
                <li className={menu === 'account' ? ("menu active  text-center") : ("menu text-center")} onClick={() => selectMenu('account')}>
                    <div className="h3 menu_icon">
                        <BiUser />
                    </div>
                    <div className="">
                        <small>アカウント</small>
                    </div>

                </li>
            </ul>
        </div>
    )
}
